import styled from 'styled-components';

export const HelpItemContainer = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    width: 64px;
    height: 64px;
    background-color: ${({ theme }) => theme.color.primary};
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 2.6rem;
  }

  > h3 {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.1rem;
    color: #000;

    padding-bottom: 1.8rem;
    border-bottom: 1px solid rgba(170, 170, 170, 0.64);
    margin-bottom: 1.8rem;
  }

  > p {
    font-weight: 400;
    font-size: 1.1rem;
    line-height: 1.65rem;
    color: #2a2a2a;

    margin-bottom: 2.6rem;
  }

  > a {
    display: block;
    margin-top: auto;

    width: fit-content;
    padding: 1rem 1.6rem;
    background-color: ${({ theme }) => theme.color.primary};
    border-radius: 5px;

    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #fff;

    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }
`;
